<router-outlet></router-outlet>
<div *ngIf="((loader$|async).isLoading_facilitySearch)">
    <opt-mmc-loader></opt-mmc-loader>
</div>


